import React from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { withTranslationCustom } from 'lib/i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { graphql } from '@apollo/client/react/hoc'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ControlledModal from 'components/Modal/ControlledModal'
import Loading from 'components/Util/Loading'
import VehiclePictures from 'components/Vehicles/VehicleProfile/VehicleProfileDetails/VehiclePictures/VehiclePictures'

import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'

import './vehicle-pictures-modal.css'

const VehiclePicturesModal = ({ t, data, editMode, location, ...rest }) => {
    const { loading, error, vehicle } = data
    let initialTitle = t('vehicleProfile:pictures.modal.title')

    if (location.pathname.includes('kuvat/muokkaa')) {
        initialTitle = t('vehicleProfile:pictures.modal.editTitle')
    }

    return (
        <ControlledModal
            routedModal
            name="vehicle-pictures-modal"
            context="vehiclePicturesModal"
            initialTitle={initialTitle}
            requireUserInput={false}
        >
            {(modalProps) => (
                <Loading loading={loading} error={error}>
                    {() => (
                        <div className="vehicle-pictures-modal__content">
                            <VehiclePictures
                                images={vehicle.images || []}
                                vehicle={vehicle}
                                editMode={editMode}
                                onClose={modalProps.closeModal}
                                renderButtonsPortalTarget={modalProps.mobileButtonsDOMElement}
                                threeImagesInRow={true}
                                setModalTitle={modalProps.setTitle}
                            />
                        </div>
                    )}
                </Loading>
            )}
        </ControlledModal>
    )
}

VehiclePicturesModal.propTypes = {
    editMode: PropTypes.bool,
}

export default flowRight(
    withErrorBoundaryNoRender,
    withTranslationCustom('vehicleProfile'),
    withRouter,
    graphqlCurrentUserCached,
    graphql(getVehicleProfileView, {
        options: ({ match, currentUser }) => ({
            variables: {
                vehicleId: match.params.vehicleId,
                userId: currentUser.me.id,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        })
    })
)(VehiclePicturesModal)
